/* eslint-disable no-plusplus */
/* eslint-disable prettier/prettier */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-param-reassign */
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { actions as modalActions } from "@gc-npm/reducers.modals-reducer";
import dynamic from "next/dynamic";
import { LINK_TARGET } from "./enums";
import {
  BEHAVIOUR_KIND,
  generateOnHandlerMethods,
  extendsAccesibility,
  appendHost,
  getReadyLinkForDev,
  currentEnv,
  checkIfHasHrefOperators,
} from "./utils";

const IconGlyph = dynamic(() => import("@gc-npm/components.icon-glyph"));

/**
 * Componente que permite hacer cualquier elemento un componente clickable.
 */
const NextLink = (props) => {
  const [stateProps, setStateProps] = useState({ ...props });
  const {
    id,
    children,
    className,
    internal,
    taggingInfo,
    tabIndex,
    title: cmpTitle,
    target,
    ariaLabel: cmpAriaLabel,
    ariaSelected,
    ariaChecked,
    ariaExpanded,
    ariaCurrent,
    screenReadable: cmpScreenRedable,
    cms,
    cmsHandler = null,
    style,
    buttonParent,
    buttonTypeHtml,
    disabled,
    cyData,
    dataAbt, // ✅ NUEVO: AB Tasty
    alias,
    context,
    addModal,
    additionalContent,
    additionalContentHeader,
    handledBySa2m,
    isAstroHref, // Flag de astro maker para fichas desde el editor
  } = stateProps;
  let { href, onClick, accessibleRole } = stateProps;

  useEffect(() => {
    setStateProps((prev) => ({
      ...prev,
      ...props,
    }));
  }, [props]);

  useEffect(() => {
    if (!handledBySa2m) return;

    const handler = (event) => {
      const { data } = event;
      const myCurrentSuscription = `update-props:${handledBySa2m}`;
      if (data?.type === myCurrentSuscription) {
        setStateProps((prev) => ({
          ...prev,
          ...data.newProps,
        }));
      }
    };

    window.addEventListener("message", handler);

    return () => {
      window.removeEventListener("message", handler);
    };
  }, []);

  const hasChildren = !!children;

  const { title, ariaLabel, ariaHidden } = extendsAccesibility({
    cmpTitle,
    hasChildren,
    cmpAriaLabel,
    cmpScreenRedable,
    taggingInfo,
  });

  const isCmsModalPageHref =
    href && href.indexOf(BEHAVIOUR_KIND.CMS_MODAL_PAGE) > -1;
  const isCmsModalContentHref =
    href && href.indexOf(BEHAVIOUR_KIND.CMS_MODAL_CONTENT) > -1;
  const isAnchor = href && href.indexOf(BEHAVIOUR_KIND.ANCHOR) > -1;

  let currentClassName = `next-link${className ? ` ${className}` : ""}`;
  isCmsModalPageHref ? (currentClassName += " hiddenNavigation") : "";
  let finalCssName = currentClassName;
  if (!children) {
    finalCssName = `${finalCssName} nextLinkOverBox`;
  }

  if (handledBySa2m) {
    finalCssName = `${finalCssName} handled-by-sa2m:${handledBySa2m}`;
  }

  const {
    newOnClick: onClickHandler,
    newOnKeyDown: onKeyDownHandler,
    newOnMouseDown: onMouseDownHandler,
  } = generateOnHandlerMethods({
    onClick,
    buttonTypeHtml,
    context,
    taggingInfo,
    disabled,
    isAnchor,
    isCmsModalPageHref,
    isCmsModalContentHref,
    addModal,
    alias,
    href,
    additionalContent,
    additionalContentHeader,
    isAstroHref,
  });

  // personalizo
  if (cmsHandler) {
    currentClassName = `${currentClassName} element-editable`;
    if (children) {
      return (
        <>
          <button
            type="button"
            onClick={() =>
              cmsHandler({
                ...props,
                name: "custom-link",
              })
            }
            className={`${currentClassName} svg-layout-size cms-custom-link-placeholder`}
            aria-label="Editar enlace"
          >
            <IconGlyph id="anchor-link-enlace-m" height={20} color="white" />
          </button>
          {children}
        </>
      );
    }
    return (
      <button
        type="button"
        className={`${currentClassName} svg-layout-size cms-custom-link-no-children-placeholder`}
        onClick={
          cms && cmsHandler
            ? () =>
                cmsHandler({
                  ...props,
                  name: "custom-link",
                })
            : null
        }
        aria-label="Editar enlace"
      >
        <IconGlyph id="anchor-link-enlace-m" height={20} color="white" />
      </button>
    );
  }

  // Devolvemos children en el cms cuando no hay enlace
  if (cms && children && href === "" && !onClick) {
    return children;
  }

  const renderAsButton =
    (!href && onClick) ||
    buttonTypeHtml === "submit" ||
    isCmsModalPageHref ||
    isAnchor ||
    isCmsModalContentHref;

  // 0) vemos si tiene href sino tiene solo es un elemento para taggear (TODO)
  if (renderAsButton) {
    return (
      <button
        id={id || null}
        type={buttonTypeHtml}
        className={finalCssName}
        tabIndex={tabIndex}
        aria-label={ariaLabel}
        aria-hidden={ariaHidden}
        aria-selected={ariaSelected}
        aria-checked={ariaChecked}
        aria-expanded={ariaExpanded}
        aria-current={ariaCurrent}
        role={accessibleRole}
        title={title}
        onClick={onClickHandler}
        onKeyDown={onKeyDownHandler}
        onMouseDown={onMouseDownHandler}
        disabled={disabled}
        style={style}
        data-cy={cyData}
        data-abt={dataAbt} // ✅ NUEVO
      >
        {buttonParent && <div className="hover-layer" />}
        {children}
        {/* INJECT_STYLED_JSX_TAG_GLOBAL */}
      </button>
    );
  }

  const hasOperators = checkIfHasHrefOperators(href);

  // "2 ) logica de link as usual"
  if (!internal && currentEnv === "dev" && !hasOperators && !isCmsModalContentHref) {
    href = getReadyLinkForDev(href);
  }

  // Cambiamos las rutas relativas que son del editor
  if (process.env.NEXT_PUBLIC_ASTRO_MAKER && isAstroHref) {
    const [path, query] = href.split("?"); // separa ruta y parámetros
    href = `/astro-maker/page/edit/?page=${path}${query ? "&" + query : ""}`;
  }

  if (!internal && !hasOperators && href && !isCmsModalContentHref) {
    href = appendHost(href);
  }

  if (!href && !onClick) {
    return null;
  }

  return (
    <a
      id={id || null}
      className={finalCssName}
      tabIndex={tabIndex}
      aria-label={ariaLabel}
      aria-hidden={ariaHidden}
      aria-selected={ariaSelected}
      aria-checked={ariaChecked}
      aria-expanded={ariaExpanded}
      aria-current={ariaCurrent}
      role={accessibleRole}
      title={title}
      href={href}
      target={target}
      rel={target === "_blank" ? "noopener noreferrer" : ""}
      onClick={onClickHandler}
      onKeyDown={onKeyDownHandler}
      onMouseDown={onMouseDownHandler}
      disabled={disabled}
      style={style}
      data-cy={cyData}
      data-abt={dataAbt} // ✅ NUEVO
    >
      {buttonParent && <div className="hover-layer" />}
      {children}
      {/* INJECT_STYLED_JSX_TAG_GLOBAL */}
    </a>
  );
};

const mapStateToProps = (state) => ({
  context: state.main.context,
  alias: state.main.orionAlias,
});

const mapDispatchToProps = (dispatch) => ({
  addModal: (data) => dispatch(modalActions.addModal(data)),
});

NextLink.propTypes = {
  id: PropTypes.string,
  href: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onClick: PropTypes.func,
  className: PropTypes.string,
  taggingInfo: PropTypes.object,
  target: PropTypes.string,
  title: PropTypes.string,
  ariaLabel: PropTypes.string,
  ariaSelected: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  ariaChecked: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  accessibleRole: PropTypes.string,
  ariaExpanded: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  disabled: PropTypes.bool,
  screenReadable: PropTypes.bool,
  buttonTypeHtml: PropTypes.string,
  buttonParent: PropTypes.bool,
  style: PropTypes.object,
  cyData: PropTypes.string,
  dataAbt: PropTypes.string, // ✅ NUEVO
  internal: PropTypes.bool,
  cms: PropTypes.object,
  cmsHandler: PropTypes.func,
  tabIndex: PropTypes.string,
  handledBySa2m: PropTypes.string,
};

NextLink.defaultProps = {
  id: null,
  className: "",
  target: "_self",
  screenReadable: true,
  disabled: false,
  onClick: null,
  buttonTypeHtml: "button",
  buttonParent: false,
  style: {},
  cyData: "",
  dataAbt: "", // ✅ NUEVO
  internal: false,
  cms: null,
  cmsHandler: null,
  tabIndex: "0",
  handledBySa2m: "",
};

export default connect(mapStateToProps, mapDispatchToProps)(NextLink);
